import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = '/configuraciones/sidebar-config/';

/**
 * GET Sidebar Config (módulos ocultos de la entidad del usuario autenticado)
 * @returns {Promise<{hidden_modules: string[]}>}
 */
export const getSidebarConfig = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return { hidden_modules: [] };
};

/**
 * PUT Sidebar Config
 * @param {string[]} hiddenModules
 * @returns {Promise<object|boolean>}
 */
export const putSidebarConfig = async (hiddenModules) => {
  try {
    const response = await API.put(baseURI, { hidden_modules: hiddenModules });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
